function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 576 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M555.324,202.166l-25.795,-14.263l-244.789,-131.213l-244.79,131.213c-8.072,4.599 -13.077,13.234 -13.077,22.561c0,9.326 5.005,17.962 13.077,22.56l64.228,35.786l0,122.915c0,42.676 34.932,77.794 77.384,77.794l206.356,-0c42.451,-0 77.383,-35.118 77.383,-77.794l0,-122.915l51.589,-29.044l0,74.164c0,14.226 11.644,25.932 25.795,25.932c14.15,-0 25.794,-11.706 25.794,-25.932l0,-89.204c-0.016,-9.343 -5.054,-17.982 -13.155,-22.56Zm-460.833,61.246l61.276,34.181c0,0 126.831,66.656 128.973,66.385c2.141,0.271 128.972,-66.385 128.972,-66.385l51.589,-28.783",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.93px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.3a0a43caa8097c76c575ef95093ae44c.svg";
export { ForwardRef as ReactComponent };